
    import { cloudinaryUrl } from './cloudinary.js'
    import { initIris } from './iris.js'
    initIris()

    fetch('/data/blog.json').then(r => r.json()).then(posts => {
      const grid = document.getElementById('postGrid')
      if (!posts.length) return
      grid.innerHTML = posts.map(p => `
        <a class="post-card" href="./blog/${p.slug}.html" style="color:inherit;">
          <img class="thumb" src="${cloudinaryUrl(p.coverImage, 'w_600,q_auto,f_auto')}" alt="${p.title}">
          <p class="cat">${p.category || ''}</p>
          <h3>${p.title}</h3>
          <p>${p.excerpt || ''}</p>
          <time datetime="${p.date}">${new Date(p.date).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</time>
        </a>
      `).join('')
    }).catch(() => {})

    const navToggle   = document.querySelector('.nav-toggle')
    const mobileNav   = document.getElementById('mobileNav')
    const mobileClose = document.querySelector('.mobile-nav-close')
    navToggle.addEventListener('click', () => mobileNav.classList.add('open'))
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'))
    document.querySelectorAll('.mobile-nav-link').forEach(l => l.addEventListener('click', () => mobileNav.classList.remove('open')))
  